import { useQuery } from "@tanstack/react-query";
import fetch from "logic/rest/FetchProvider";
import { qualifyUrl } from "util/URLUtils";
import { defaultOnError } from "util/conditional/onError";
const useMinimumRefreshInterval = () => {
  const { data, isInitialLoading } = useQuery({
    queryKey: ["system", "configuration", "minimum-refresh-interval"],
    queryFn: () => defaultOnError(
      fetch("GET", qualifyUrl("/system/configuration/minimum_auto_refresh_interval")),
      'Loading system configuration "minimum_auto_refresh_interval" failed with status',
      "Could not load configuration option"
    )
  });
  return { data: data == null ? void 0 : data.value, isInitialLoading };
};
export default useMinimumRefreshInterval;
